import React from "react";
import { withRouter } from "react-router";
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import { Button, Grid, Icon, Header, List, Accordion } from "semantic-ui-react";
import CreateInitiativeSteps from "./Steps";
import { dispatch } from '@rematch/core';
import IntegrationTree from './../../Drive/Tree/IntegrationTree'

class Integration extends React.Component {

    async componentWillMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        dispatch.initiatives.setTabName("integration");
        let selectedDataById = this.props.selectedDataById;

        let objValidation = Object.entries(selectedDataById).length === 0 && selectedDataById.constructor === Object
        if (objValidation) {
            await dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        }
    }

    backClick() {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/configureActivity/' + this.props.match.params.initiativeId
        });
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        // dispatch.lifeCycle.disableLinking();
        // dispatch.lifeCycle.setDependencyIcon(false);
        // dispatch.initiatives.setSelectedActivityData({});
    }

    render() {
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50;

        return (
            <div ref={this.parentRef} style={{ width: "100%", maxHeight: designerHeight ? designerHeight : 200, overflowY: "scroll" }}>
                <Grid className="containerBoxFullWidth">
                    <Grid.Row >
                        <BreadCrumbs {...this.props} />
                    </Grid.Row>
                    <Grid.Row >
                        <CreateInitiativeSteps {...this.props} setPage="integration" />
                    </Grid.Row>


                    <Grid.Row >
                        <Grid className="w_100"  >
                            <Grid.Row className="configureActivity" >
                                <Grid.Column width={16}>
                                    <Header as='h4' >Integration</Header>
                                </Grid.Column >
                                <Grid.Column width={16}>
                                    <IntegrationTree />
                                </Grid.Column >
                            </Grid.Row>
                        </Grid >
                    </Grid.Row>


                    <Grid.Row >
                        <Grid className="w_100"  >
                            {this.props.selectedDataById.status === 0 ?
                                <Grid.Row>
                                    <Grid.Column width={8} className="pad_0">
                                        <div className="bottom_button_set" >
                                            <Button
                                                disabled={this.props.buttonStatus}
                                                onClick={() => this.backClick()}
                                                type="button"
                                                className="button-cancel" >Previous </Button>
                                        </div>
                                    </Grid.Column >
                                    <Grid.Column width={8} className="pad_0">
                                        <div className="bottom_button_set" style={{ textAlign: "right" }} >
                                            <Button
                                                disabled={!this.props.isDurationSet}
                                                //loading={this.state.loader}
                                                type='submit'
                                                id='next'
                                                className="button-submit"
                                                onClick={() => this.next()} > Next </Button>
                                        </div>
                                    </Grid.Column >
                                </Grid.Row> : ""}
                        </Grid >
                    </Grid.Row>
                </Grid>

            </div>
        );
    }
}
export default withRouter(Integration);
